import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from '@/utils/axiosConfig';
import { useAuth } from './AuthContext';

const PermissionsContext = createContext();

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within PermissionsProvider');
  }
  return context;
};

export const PermissionsProvider = ({ children }) => {
  const { user, token } = useAuth();
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const API = `${BACKEND_URL}/api`;

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!token || !user) {
        setPermissions({});
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${API}/users/my-permissions`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPermissions(response.data.permissions || {});
      } catch (error) {
        console.error('Error fetching permissions:', error);
        setPermissions({});
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [user, token, API]);

  const hasPermission = (permission) => {
    return permissions[permission] === true;
  };

  const isSuperAdmin = () => {
    return user?.is_super_admin === true;
  };

  const hasRole = (role) => {
    return user?.employee_roles?.includes(role) || false;
  };

  return (
    <PermissionsContext.Provider
      value={{
        permissions,
        hasPermission,
        isSuperAdmin,
        hasRole,
        loading
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};
